import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const Offline = Loadable({
    loader: () => import(/* webpackChunkName: "Offline" */ './offline'),
    loading: () => <div />,
});
